
export class TelemetrySample{
    constructor(id, timestamp, value){
        this.id = id;
        this.timestamp = timestamp;
        this.value = value;
    }
}

export class DeviceTelemetry {

    constructor(deviceId, deviceLabel, ...samples){
        this.deviceId = deviceId;
        this.deviceLabel = deviceLabel;
        this.samples = samples;
    }
}